import { ChangeDetectorRef, Component, OnInit, Input, AfterViewInit, inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { AccountHeadRequest } from '@otas/stoda/model/account-head/account-head-request';
import { NgbActiveModal } from '@otas/modal/modal-ref';
import { RootAccountHead } from '@otas/stoda/model/account-head/account-head-details';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NgIf, NgClass } from '@angular/common';
import { UtilsModule } from '@otas/utils/utils.module';

@Component({
    selector: 'app-add-or-update-acc-head-modal',
    templateUrl: './add-or-update-acc-head-modal.component.html',
    styleUrls: ['./add-or-update-acc-head-modal.component.css'],
    imports:[NgIf, NgClass, UtilsModule, ReactiveFormsModule]
})
export class AddOrUpdateAccHeadModalComponent implements OnInit, AfterViewInit {
  isEdit = false;
  submitted = false;
  accountHeadAddForm: UntypedFormGroup;
  accountHeadToEdit: RootAccountHead;
  @Input() accountHeadWithTitles: any[] = [];
  @Input() accountParentHeadWithTitles: any[] = [];
  componentDestroySubject = new Subject();
  accountParentHeadWithTitlesTemp;
  private cdr = inject(ChangeDetectorRef);
  constructor(fb: UntypedFormBuilder, private activeModal: NgbActiveModal) {
    this.accountHeadAddForm = fb.group(new AccountHeadRequest());
    this.accountParentHeadWithTitlesTemp = this.accountParentHeadWithTitles;
  }

  ngOnInit() { }

  ngAfterViewInit() {
    this.accountParentHeadWithTitlesTemp = this.accountParentHeadWithTitles;
    if (!!this.accountHeadToEdit) {
      this.accountHeadAddForm.patchValue(this.accountHeadToEdit);
      this.accountParentHeadWithTitles = this.accountParentHeadWithTitlesTemp.filter((obj) => {
        return obj.id === this.accountHeadToEdit.accountTypeId;
      });
    }
    this.accountHeadAddForm.controls.accountTypeId.valueChanges.pipe(debounceTime(200), distinctUntilChanged(), takeUntil(this.componentDestroySubject))
      .subscribe((data) => {
        if (!!data) {
          this.accountParentHeadWithTitles = this.accountParentHeadWithTitlesTemp.filter((obj) => {
            return obj.id === data;
          });
          this.cdr.markForCheck();
        }
      });
  }

  clear() {
    this.activeModal.close(false);
  }

  onbankChanged(ev) {
    this.accountHeadAddForm.controls.bank.setValue(ev);
  }

  saveHead() {
    if (this.accountHeadAddForm.invalid) {
      this.submitted = true;
      return;
    }
    this.activeModal.close(this.accountHeadAddForm.value);
  }

}
